<template>
  <div>
    <el-card
      shadow="never"
      :body-style="{
        padding: '20px 15px',
      }"
    >
      <div v-if="!isEmpty">
        <Timeline>
          <TimelineItem
            v-for="(item, index) in quotationData"
            :key="index"
            v-bind="item"
          >
            <template #default="{ item }">
              <div class="quotation__container mt-2">
                <div class="quotation__table">
                  <vxe-grid
                    ref="table"
                    auto-resize
                    highlight-hover-row
                    :data="item.content"
                    :columns="tableColumns"
                    :loading="loading"
                    size="small"
                    cell-class-name="align-top"
                    resizable
                    border="inner"
                    :seq-config="{
                      startIndex: 0,
                    }"
                  >
                    <template
                      v-slot:displayImage="{ row: { defaultImageUrl } }"
                    >
                      <el-image
                        :src="defaultImageUrl || '/image/static/img/nopic.jpg'"
                        :preview-src-list="[
                          defaultImageUrl || '/image/static/img/nopic.jpg',
                        ]"
                        style="width: 100px; height: 66px"
                        fit="cover"
                      >
                        <div slot="error" class="image-slot">
                          <img
                            src="/image/static/img/nopic.jpg"
                            style="width: 100px; height: 66px"
                          />
                        </div>
                      </el-image>
                    </template>
                    <template v-slot:productName="{ row }">
                      <span>ABSXP24010001-1-1</span>
                      <br />
                      <span>印花帆布坐垫</span>
                      <br />
                      <span> printing canvas chair cushion</span>
                    </template>
                    <template v-slot:sizeColor="{ row }">
                      <span>18*18 Inch</span>
                      <br />
                      <span>灰白色 Gray/White</span>
                    </template>
                    <template v-slot:confirmOrderQuantity="{ row }">
                      <span>3000 / 套</span>
                    </template>
                    <template v-slot:price="{ row }">
                      <span>报价方式：FOB</span>
                      <br />
                      <span>下单价格：9.99 美元</span>
                    </template>
                    <template v-slot:costPriceFactory="{ row }">
                      <span>成本价格：20.26 人民币</span>
                      <br />
                      <span>苏州合祥纺织科技有限公司</span>
                    </template>
                    <template v-slot:latestChanges="{ row }">
                      <span>Admin-系统管理员</span>
                      <br />
                      <span>2023-07-26 10:10:10</span>
                    </template>
                  </vxe-grid>
                </div>
              </div>
            </template>
          </TimelineItem>
        </Timeline>
      </div>
      <div v-else class="not-data__container">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data mt-2">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </div>
    </el-card>
  </div>
</template>
<script>
import tableColumns from './table-columns'
import Timeline from '../timeline/index.vue'
import TimelineItem from '../timeline/item.vue'
export default {
  props: {
    detailData: {
      type: Object,
      default: () => {
        return {}
      },
    },
    devTrackingCode: { type: String, default: '' },
  },
  components: { Timeline, TimelineItem },
  data() {
    return {
      quotationData: [
        {
          type: 'C',
          title: '翻单订单',
          time: '2024-01-10 10:10:30',
          name: 'Ping-鄢萍',
          avatar:
            'https://abs-oss.oss-cn-shanghai.aliyuncs.com/202211/eb0e81e1ace7616d9fe1f1008cf9c39f.jpg?Expires=2017386112&OSSAccessKeyId=LTAI4G9GTRRdivUVG4GXBpXM&Signature=n0PPMOE712DKaryzWZeRn03cOro%3D',
          content: [
            {
              productMaterial:
                'Face：\n100% Polyester,cationic dye, 1400gsmFace\nBack：\nSEBS anti-slip hot melt glue',
            },
          ],
        },
        {
          type: 'C',
          title: '翻单订单',
          time: '2024-01-10 10:10:30',
          name: 'Ping-鄢萍',
          avatar:
            'https://abs-oss.oss-cn-shanghai.aliyuncs.com/202211/eb0e81e1ace7616d9fe1f1008cf9c39f.jpg?Expires=2017386112&OSSAccessKeyId=LTAI4G9GTRRdivUVG4GXBpXM&Signature=n0PPMOE712DKaryzWZeRn03cOro%3D',
          content: [{}],
        },
      ],
      loading: false,
      tableColumns: tableColumns(this),
    }
  },
  computed: {
    isEmpty() {
      return !this.quotationData || !this.quotationData.length
    },
  },
}
</script>
<style lang="scss" scoped>
.w-140 {
  width: 140px;
}
.flex-none {
  flex: none !important;
}
.flex-1 {
  flex: 1;
}
.product-descriptions__container {
  display: flex;
  flex-direction: column;
  border: 1px solid #efefef;
  border-bottom: none;
  .row__container {
    border-bottom: 1px solid #efefef;
    display: flex;
    .various {
      display: flex;
      flex: 1;
      align-items: center;
      .various_label {
        padding: 10px 10px;
        width: 100px;
        height: 100%;
        background-color: #fafafa;
        color: #999a9f;
        font-size: 13px;
        display: flex;
        border-right: 1px solid #efefef;
      }
      .various_value::-webkit-scrollbar {
        display: none;
      }
      .various_value {
        height: 100%;
        overflow: -moz-scrollbars-none;
        padding: 10px 10px;
        display: flex;
        align-items: center;
        flex: 1;
        font-size: 13px;
        color: #4f4f4f;
        align-content: center;
        border-right: 1px solid #efefef;
        overflow: scroll;
        -ms-overflow-style: none;
      }
    }
    > .various:last-child {
      .various_value {
        border-right: none;
      }
    }
  }
  > .row__container:last-child {
    border-bottom: none;
  }
}
.quotation__table {
  border: 1px solid #efefef;
  border-bottom: none;
}
.quotation__container {
  padding-bottom: 20px;
}
.not-data__container {
  height: 500px;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
